import React, { useState, useRef } from 'react'
import Timer from '../../timer/timer';
import Video from '../../video/video';
import Audio from '../../audio/audio';
import "./index.css";
import Chressage from '../chess/src/components/game';
import '../chess/src/index.css';

import styled, { keyframes } from 'styled-components';
import { fadeIn } from 'react-animations';

import { memo } from 'react';
import Modal from 'react-modal';



const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        background: 'none',
        border: 'none',
    },
};

const AnimationSlide = keyframes`${fadeIn}`;

const SlideDownInDiv = styled.div`
  animation: 2s ${AnimationSlide};
`;


// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('#root');

const ChressageGame = (props) => {
    const actorName = "PATTY";
    const actorTitle = "Horse Trainer";
    const playVideo = useRef(null);
    const playAudio = useRef(null);
    const timerRef = useRef(null);

    const posterURL = './actors/Patty.png';

    const congratulateVideoURL = './videos/7_1_Finale_01.mp4';

    const waitingVideoURL = './videos/waitings/Patty_Waiting.mp4';

    const promptVideos = ['./videos/CNE-16-Patty-Prompt-01.mp4', './videos/CNE-16-Patty-Prompt-02.mp4', './videos/CNE-16-Patty-Prompt-03.mp4'];

    const [promptIndex, setPromptIndex] = useState(null);

    const [currentVideoURL, setCurrentVideoURL] = useState(null)

    let btnRef = useRef();

    //modal

    const [gameOverModalIsOpen, setGameOverModalIsOpen] = useState(false);

    function openGameOverModal() {
        setGameOverModalIsOpen(true);
    }

    function closeGameOverModal() {
        timerRef.current(props.initialTimeOut);
        setGameOverModalIsOpen(false);
    }
    function restartGame() {
        setGameOverModalIsOpen(false);
        props.goToStep(null, 'LandingPage');

    }
    //modal end

    const [seed, setSeed] = useState(1);

    const gotoFailed = (event, args) => {

        if (gameOverModalIsOpen) {

        } else {
            openGameOverModal();
        }
    }

    const playWaitingVideo = () => {

        setCurrentVideoURL(waitingVideoURL);
        playVideo.current(waitingVideoURL);

    }
    const failedMove = () => {

        if (promptIndex === null) {
            setPromptIndex(0);
            playVideo.current(promptVideos[0]);
        } else if (promptIndex === 0) {
            setPromptIndex(1);
            playVideo.current(promptVideos[1]);
        } else if (promptIndex === 1) {
            setPromptIndex(2);
            playVideo.current(promptVideos[2]);
        } else if (promptIndex === 2) {
            setPromptIndex(0);
            playVideo.current(promptVideos[0]);
        } else {
            setPromptIndex(0);
            playVideo.current(promptVideos[0]);
        }
    }
    const handleSucces = () => {
        if (btnRef.current) {
            btnRef.current.setAttribute("disabled", "disabled");
        }
        setCurrentVideoURL(congratulateVideoURL);
        playVideo.current(congratulateVideoURL);
    }
    const handleSubmit = (event) => {

        event.preventDefault();
        // props.goToStep(null, 'GeneralIntro');
        resetGame();
    }

    const resetGame = () => {

        setSeed(Math.random());
    }

    const updateVideoStatue = (value, src) => {

        if (value === "ended") {
            if (currentVideoURL === congratulateVideoURL) {
                props.goToStep(null, 'FinalPuzzleIntro');
            } else if (waitingVideoURL === currentVideoURL) {
                playWaitingVideo();
            } else if (promptVideos.includes(currentVideoURL)) {
                playWaitingVideo();
            } else {
                playWaitingVideo();
            }

        }

    }

    const updateAudioStatue = (value) => {

    }

    const setUpWarningSound = () => {
        if (playAudio.current) {
            playAudio.current('./musics/30SecondTimer.mp3');
        }
    }


    return (

        <div className="chressageGame">
            <div className='chressageContainer'>
                <div className='headerRow'>
                    <div className='pgTitle'>
                        <div className='gameTitleContainer'>
                            <div className='pgName'>Horse Palace</div>
                            <div className='pgDesc'>Chressage</div>
                        </div>
                        <SlideDownInDiv>
                            <div className='hintContainer'>
                                <p>Click the moves in each photo below. Use ALL of them to move the horse to the X. Press RESET to start again.</p>
                            </div>
                        </SlideDownInDiv>
                    </div>

                </div>
                <div className='gameContent'>
                    <Chressage key={seed} failedMove={failedMove} handleSucces={handleSucces}></Chressage>
                </div>
            </div>
            <div className='videoContainer'>
                <Timer seconds={props.seconds} gotoFailed={gotoFailed} isReversed={props.isReversed} setUpWarningSound={setUpWarningSound} timerRef={timerRef} updateTimerValue={props.updateTimerValue} />

                <Video VideoURL="./videos/6_2_Minigame_Intro.mp4" actorName={actorName} actorTitle={actorTitle} poster={posterURL} updateVideoStatue={updateVideoStatue} playVideo={playVideo} />

                <Modal
                    isOpen={gameOverModalIsOpen}
                    style={customStyles}
                    contentLabel="Game over"
                >
                    <div className="timeOutPopup">
                        <div className='timeoutContainer'>
                            <div className='timeoutLabel' />
                            <div className='paperContainer' />
                            <div className='timeoutPictures'>
                                <div className='pic1'></div>
                                <div className='pic2'></div>
                                <div className='pic3'></div>
                            </div>
                            <div className='timeoutMessage'>
                                Oops you've run out of time!
                            </div>
                            <div className='timoutButtonsContainer'>
                                <button className='timeoutButton' onClick={closeGameOverModal} >Continue?</button>
                                <button className='timeoutButton' onClick={restartGame}>Restart</button>
                            </div>
                        </div>
                    </div>
                </Modal>

                <div>
                    <form onSubmit={handleSubmit}>
                        <input className="submitButton" onClick={resetGame} ref={btnRef} type="reset" value="Reset" />
                    </form>
                </div>
            </div>
            <Audio AudioURL="./musics/the-crackdown.mp3" autoPlay loop updateAudioStatue={updateAudioStatue} playAudio={playAudio} />

        </div>
    );

};

export default memo(ChressageGame);